export interface DialogParams {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Dialog = ({ children, isOpen, onClose }: DialogParams) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-xs flex items-center justify-center z-100"
      id="dialog-container"
      onClick={handleBackdropClick}
    >
      {children}
    </div>
  );
};
